module.exports = __webpack_public_path__ + "img/img1.f66fc7e0.jpg";